import React from "react";
import Button from "../Button";
import LineVertical from "../LineVertical";
import "./footer-consultation.scss";

export const FooterConsultation = () => {
  return (
    <div className="about-footer wrapper">
      <LineVertical />
      <div className="about-footer-content">
        <h2 data-aos="fade-up" data-aos-duration="1000">
          Organizations with moving stories create movements of change.
        </h2>
        <Button
          text="Book a Consultation"
          isNewWindow
          href="https://wakefield.agency/contact-us"
          style={{ justifyContent: "center" }}
        />
        <div style={{ height: "40px" }} />
      </div>
    </div>
  );
};
